import initApiRoutes, { ApiRoutes } from 'global/lib/api/apiRoutes'

import API_ROUTES from 'fir/configs/api_routes'

const apiRoutes: ApiRoutes = initApiRoutes({ API_ROUTES })

export default apiRoutes
